module.exports = __webpack_public_path__ + "static/img/0547_8.cd61ad8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_8.jpg
// module id = +Adz
// module chunks = 1